<template>
    <div class="apply w1200">
        <img src="@/assets/apply/topImage.png" alt="" class="topImage" />
        <el-form label-width="280px">
            <el-form-item label="手机：">
                <el-input placeholder="请输入内容" clearable />
            </el-form-item>
            <el-form-item label="邮箱：">
                <el-input placeholder="请输入内容" clearable />
            </el-form-item>
            <el-form-item label="QQ：">
                <el-input placeholder="请输入内容" clearable />
            </el-form-item>
            <el-form-item label="申请师种：">
                <el-radio-group v-model="form.a">
                    <el-radio label="分析师"></el-radio>
                    <el-radio label="排序师"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="申请彩种：">
                <el-checkbox-group v-model="form.a">
                    <el-checkbox label="双色球" name="type"></el-checkbox>
                    <el-checkbox label="大乐透" name="type"></el-checkbox>
                    <el-checkbox label="福彩3D" name="type"></el-checkbox>
                    <el-checkbox label="排列三" name="type"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="性别：">
                <el-radio-group v-model="form.a">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                    <el-radio label="保密"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="彩龄：">
                <el-radio-group v-model="form.a">
                    <el-radio label="3年以内"></el-radio>
                    <el-radio label="3~5年"></el-radio>
                    <el-radio label="5年以上"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="生日：">
                <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="form.a"
                    style="width: 100%"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="个人是否长期不间断研究并购买彩票：">
                <el-radio-group v-model="form.a">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否经常组织三五好友一起实战：">
                <el-radio-group v-model="form.a">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否经营投注站点：">
                <el-radio-group v-model="form.a">
                    <el-radio label="是"></el-radio>
                    <el-radio label="否"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否有60人以上的QQ群：">
                <el-radio-group v-model="form.a">
                    <el-radio label="有"></el-radio>
                    <el-radio label="无"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否有60人以上的微信群：">
                <el-radio-group v-model="form.a">
                    <el-radio label="有"></el-radio>
                    <el-radio label="无"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="个人简介：">
                <el-input type="textarea" />
            </el-form-item>
            <el-form-item label="我的宣言：">
                <el-input placeholder="请输入内容" clearable />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" >立即创建</el-button>
                <el-button>取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                a: "",
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.apply {
    .topImage {
        width: 100%;
    }
}
</style>